export default __webpack_public_path__ + "static/media/LGSmHaTR.63bb159f.woff2";